<div class="d-flex spacing-2">
  <app-inputs style="width: 60px" Label="" [formControl]="inputCtrlFrom"></app-inputs>
  @if (isRange) {
    <app-inputs style="width: 60px" Label="" [formControl]="inputCtrlTo"></app-inputs>
  }
</div>
